import { openReauthPopup, persistedBackendUrl } from './auth';

// Single-flight переаутентификация. При 401 (authFetch) или проактивно (по таймеру сессии)
// показываем модалку и держим один общий промис на все параллельные запросы: попап
// открывается один раз, после завершения все ждущие запросы повторяются.
//
// Cookie сессии общий для всех вкладок, поэтому успешный логин в одной вкладке
// восстанавливает сессию для всех — оповещаем соседние через BroadcastChannel.

let pending = null; // { promise, resolve }
const listeners = new Set(); // подписчики (visible, success): ReauthModal — видимость, Root — результат

const channel =
  typeof BroadcastChannel === 'undefined' ? null : new BroadcastChannel('vizorlytics-reauth');

const notify = (visible, success) => listeners.forEach((listener) => listener(visible, success));

// Завершить реаутентификацию: скрыть модалку (с сигналом success/failure) и разбудить
// ждущие запросы (повтор).
const settle = (success) => {
  if (!pending) {
    return;
  }
  const { resolve } = pending;
  pending = null;
  notify(false, success);
  resolve(success);
};

if (channel) {
  channel.onmessage = (event) => {
    if (event.data === 'success') {
      settle(true);
    }
  };
}

// Подписка на состояние реаутентификации. listener(visible, success): visible — видимость
// модалки; success определён только при завершении (visible === false).
export const subscribeReauth = (listener) => {
  listeners.add(listener);
  return () => listeners.delete(listener);
};

// Запросить переаутентификацию (single-flight). Возвращает общий промис, по которому
// authFetch дожидается и повторяет запрос; результат прилетает слушателям через settle.
export const requestReauth = () => {
  if (!pending) {
    let resolve;
    const promise = new Promise((res) => {
      resolve = res;
    });
    pending = { promise, resolve };
  }
  notify(true);
  return pending.promise;
};

// Вызывается по клику "Sign in" в модалке — user gesture, иначе попап блокируется.
export const startReauthPopup = () =>
  openReauthPopup(persistedBackendUrl())
    .catch(() => false)
    .then((succeeded) => {
      // Соседние вкладки будим только при подтверждённом успехе, иначе они словят 401 снова.
      if (succeeded && channel) {
        channel.postMessage('success');
      }
      settle(!!succeeded);
    });
